
import { ISize } from '@uifabric/utilities/lib/ISize';
import { ControlFacet } from '../models/controls/ControlFacet';

export interface IImage {
  url: string;
  width: number;
  height: number;
}

export interface IItemThumbnailControlProps {
  itemKey: string;
  originalImage?: IImage;
  desiredSize: ISize;
}

export interface IItemThumbnailControlOverrides {
  thumbnail: IImage;
}

export const itemThumbnailControl: ControlFacet<IItemThumbnailControlProps, IItemThumbnailControlOverrides> =
  new ControlFacet('itemThumbnailControl');
